import React, { useState } from 'react';
import '../Css/AdminRegister.css';
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CircularProgress from '@mui/material/CircularProgress'; // Make sure to install Material-UI
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ResetPassword = ({ email: initialEmail, onSubmit }) => {
    const [email, setEmail] = useState(initialEmail || '');
    const [otp, setOTP] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false); // State to manage loading
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const navigate = useNavigate();

    const handleSendOTP = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error('Email is required');
            return;
        }

        setLoading(true); // Set loading to true when OTP send process starts
        try {
            const response = await fetch(`/api/forgotPassword/forgotPasswords`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Email not Registered with Us. Kindly Signup');
            }

            setOtpSent(true);
            toast.success('OTP sent successfully');
        } catch (error) {
            toast.error(error.message || 'Email not Registered with Us. Kindly Signup');
        } finally {
            setLoading(false); // Set loading to false once the OTP send process is complete
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            toast.error("New and confirm password should be same");
            return;
        }

        if (!email || !otp || newPassword !== confirmPassword) {
            toast.error('Please fill all fields correctly');
            return;
        }
        try {
            const response = await fetch(`/api/forgotPassword/resetPassword`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email,
                    otp,
                    newPassword
                })
            });

            const data = await response.json();

            if (response.status === 201) {
                toast.error("Password cannot be the same as the previous one.");
                return;
            }

            if (!response.ok) {
                throw new Error(data.message || 'Invalid OTP. Failed to reset password.');
            }

            toast.success('Password changed successfully!');
            setTimeout(() => navigate('/'), 3000);

        } catch (error) {
            toast.error(error.message || 'Invalid OTP. Failed to reset password.');
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    };

    return (
        <div className="reset-password-container">
            <ToastContainer />
            <div className="reset-password-box">
                <div className="reset-password-header">
                    <h3>Reset Password</h3>
                </div>
                {!otpSent ? (
                    <>
                        <p className='resetPasswordInfoMessage'>Enter your email to receive OTP:</p>
                        <form className="reset-password-form" onSubmit={handleSendOTP} autoComplete="off">
                            <div className="form-group">
                                <label>Email
                                    <span className="requiredFields">*</span>
                                </label>
                                <div className='otpLoadingBox'>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter your email"
                                        required
                                        autoComplete="off"
                                    />
                                    {loading && (
                                        <div className="otp-loading-forgot-password">
                                            <CircularProgress size={24} />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <button type="submit" disabled={loading}>Send OTP</button>
                        </form>
                    </>
                ) : (
                    <>
                        <p className='resetPasswordInfoMessage'>Enter OTP received on your email:</p>
                        <form className="reset-password-form" onSubmit={handleSubmit} autoComplete="off">
                            <div className="form-group">
                                <label>OTP
                                    <span className="requiredFields">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={otp}
                                    onChange={(e) => setOTP(e.target.value)}
                                    placeholder="Enter OTP"
                                    required
                                    autoComplete="off"
                                />
                            </div>
                            <div className="form-group">
                                <label>New Password
                                    <span className="requiredFields">*</span>
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="Enter new password"
                                        fullWidth
                                        required
                                        autoComplete="off"
                                    />
                                    <FontAwesomeIcon
                                        icon={showPassword ? faEye : faEyeSlash}
                                        onClick={togglePasswordVisibility}
                                        style={{ marginLeft: -38, cursor: 'pointer' }}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Confirm Password
                                    <span className="requiredFields">*</span>
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type={showNewPassword ? 'text' : 'password'}
                                        name="password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="Confirm new password"
                                        fullWidth
                                        required
                                        autoComplete="off"
                                    />
                                    <FontAwesomeIcon
                                        icon={showNewPassword ? faEye : faEyeSlash}
                                        onClick={toggleNewPasswordVisibility}
                                        style={{ marginLeft: -38, cursor: 'pointer' }}
                                    />
                                </div>
                            </div>
                            <button type="submit">Reset Password</button>
                        </form>
                    </>
                )}

                <div className="additional-links-forgot-password">
                    <p>
                        <Link to="/"> Cancel</Link></p>
                </div>
                <p className='noteHereRequiredFields'>
                    <span className="requiredFields">*</span> fields are required
                </p>
            </div>
        </div>
    );
};

export default ResetPassword;
